var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('roskilde-button',{attrs:{"borderType":"partial","size":"sm","type":"light","widthType":"auto"},on:{"click":_vm.goBack}},[_vm._v("Tilbage ")])}
var staticRenderFns = []

export { render, staticRenderFns }